import React from 'react';
import { twMerge } from 'tailwind-merge';

type WebUiSelectProps = React.SelectHTMLAttributes<HTMLSelectElement> & {
  className?: string;
  inputSize?: 'sm' | 'md' | 'lg';
  options: { label: string; value: string }[];
};

export function WebUiSelect({
  className,
  inputSize = 'md',
  options,
  ...other
}: WebUiSelectProps) {
  const sizeClass = {
    sm: 'text-xs px-1 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-3 py-2',
  };

  return (
    <select
      className={twMerge('webui-input', sizeClass[inputSize], className)}
      {...other}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
